import MainLayout from '@/views/layouts/MainLayout.vue';
import ProjectsList from '@/views/ProjectsList.vue';
import Requests from '@/views/RequestsList.vue';
import Dashboard from '@/views/layouts/DashboardLayout.vue';
import { views } from '@/router/constants';
import ConfigurationLayout from '@/views/layouts/ConfigurationLayout.vue';
import NotAuthorized from '@/views/NotAuthorized.vue';
import Profile from '@/views/customer-profile/Profile.vue';
import ServiceProviderProfile from '@/views/sp-profile/ServiceProviderProfile.vue';
import ServiceProviderConfiguration from '@/views/service-provider-configuration/ServiceProviderConfiguration.vue';
import WorkFlowsLayout from '@/views/layouts/WorkFlowsLayout.vue';
import IssuesLayout from '@/views/layouts/IssuesLayout.vue';
import IntegrationsLayout from '@/views/layouts/IntegrationsLayout.vue';
import AddIntegrationLayout from '@/views/layouts/AddIntegrationLayout.vue';
import AuthenticationsLayout from '@/views/layouts/AuthenticationsLayout.vue';
import ReportsLayout from '@/views/layouts/ReportsLayout.vue';
import InsightsLayout from '@/views/layouts/InsightsLayout.vue';
import SettingsLayout from '@/views/layouts/SettingsLayout.vue';
import ThreatCanvasLayout from '@/views/layouts/ThreatCanvasLayout.vue';

export default [
  {
    path: '/main',
    component: MainLayout,
    children: [
      {
        path: '/activity-log',
        name: views.ACTIVITY_LOG,
        component: ProjectsList,
      },
      {
        path: '/issues',
        name: views.ISSUES,
        component: IssuesLayout,
      },
      {
        path: '/insights',
        name: views.INSIGHTS,
        component: InsightsLayout,
      },
      {
        path: '/playbooks',
        component: WorkFlowsLayout,
        name: views.PLAYBOOKS,
      },
      {
        path: '/threat-canvas',
        component: ThreatCanvasLayout,
        name: views.CTC,
      },
      {
        path: '/requests',
        name: views.REQUESTS,
        component: Requests,
      },
      {
        path: '/dashboard',
        name: views.DASHBOARD,
        component: Dashboard,
      },
      {
        path: '/profile',
        name: views.CUSTOMER_PROFILE,
        component: Profile,
      },
      {
        path: '/integrations',
        name: views.INTEGRATIONS,
        component: IntegrationsLayout,
      },
      {
        path: '/authentications',
        name: views.AUTHENTICATIONS,
        component: AuthenticationsLayout,
      },
      {
        path: '/reports',
        name: views.REPORTS,
        component: ReportsLayout,
      },
      {
        path: '/add-integration',
        name: views.ADD_INTEGRATION,
        component: AddIntegrationLayout,
      },
      {
        path: '/sp-profile',
        name: views.SERVICE_PROVIDER_PROFILE,
        component: ServiceProviderProfile,
      },
      {
        path: '/settings',
        name: views.SETTINGS,
        component: SettingsLayout,
      },
      {
        path: '/inventory',
        name: views.INVENTORY,
        component: ConfigurationLayout,
      },
      {
        path: '/service-provider-configuration',
        name: views.SERVICE_PROVIDER_CONFIGURATION,
        component: ServiceProviderConfiguration,
      },
      {
        path: '/not-authorized',
        name: views.NOT_AUTHORIZED,
        component: NotAuthorized,
      },
    ],
  },
];
